import { useTranslation } from 'react-i18next'
import { DONE_WINDOWS, parseDoneWindow, useDoneWindow } from '../../lib/done-window.js'

/** Selector de la cabecera de Finalizada: 7 días, 30 días o todas (CLAUDE.md §6, fase 7). */
export function DoneWindowSelect() {
  const { t } = useTranslation()
  const { doneWindow, setDoneWindow } = useDoneWindow()

  return (
    <select
      value={doneWindow}
      onChange={(event) => setDoneWindow(parseDoneWindow(event.target.value))}
      aria-label={t('board.doneWindow.label')}
      className="h-6 rounded-card bg-surface-hi px-1 text-meta text-text-muted hover:text-text focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent max-md:h-11"
    >
      {DONE_WINDOWS.map((option) => (
        <option key={option} value={option}>
          {t(`board.doneWindow.${option}`)}
        </option>
      ))}
    </select>
  )
}
